<template>
  <div class="table-toolbar">
    <div class="flex gaps auto search-box" v-if="searchbarVisible">
      <div class="flex-14 flexgaps" style="margin-right: 120px;" v-if="hasLeftToolbarSlot"><slot name="left-toolbar-tools"></slot></div>
      <div class="flex-6 search-box-container">
        <el-button
          type="text"
          class="add-search-tags-btn"
          @click="addSearchTagsToBtn()"
          :disabled="disableAddFilterBtn"
          >
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content" class="filter-tooltip-container">
              <div class="filter-tooltip-header">
                CREATE CUSTOM FILTER
              </div>
              <div class="filter-tooltip-body">
                <div>
                  <div class="filter-tooltip-body_idx">1.</div>
                  <div class="filter-tooltip-body_content">Add query into search (up to 5); press return</div>
                </div>
                <div>
                  <div class="filter-tooltip-body_idx">2.</div>
                  <div class="filter-tooltip-body_content">Type name into filter bubble, press return</div>
                </div>
              </div>
            </div>
            <i class="el-icon-circle-plus-outline"></i>
          </el-tooltip>
          add your search query as a custom filter
        </el-button>
        <vue-tags-input
          class="vue-tags-search-box"
          placeholder="Search"
          v-model="tag"
          :tags="tags"
          :validation="validation"
          :disabled="disableSearchBox"
          @tags-changed="handleTagChange"
          @blur="onInputBlur"
          @focus="onInputFocus"
        />
      </div>
      <div class="flex-8 flex gaps" style="justify-content:flex-end;" v-if="hasSearchActionsSlot">
        <slot name="search-actions"></slot>
      </div>
    </div>
    <div>
      <slot name="iocTacticList"></slot>
    </div>
    <div class="flex gaps auto"><slot name="local-helper"></slot></div>
    <div class="flex gaps auto mt-16 top-border">
      <div class="box count-info">
        <span class="body2">{{ queryCountText }}</span>
      </div>
      <div class="box icons-tools">
        <div class="" v-if="hasLocalActionsSlot">
          <slot name="local-actions"></slot>
        </div>
        <el-button-group>
          <el-tooltip
            class="item"
            effect="dark"
            content="Refresh"
            placement="top"
            :enterable="false"
            v-if="refreshVisible"
          >
            <el-button type="text" class="cursor-pointer" @click="refreshTable()">
              <i class="material-icons c-icon">refresh</i>
            </el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="Column Settings"
            placement="top"
            :enterable="false"
            v-if="columnEditVisible"
          >
            <el-dropdown trigger="click" @command="handleCommand">
              <el-button type="text" class="cursor-pointer"> <i class="material-icons c-icon">settings</i> </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="Edit Columns" icon="el-icon-edit">Edit Columns</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-tooltip>
        </el-button-group>
        <slot name="toolbar-tools"></slot>
      </div>
    </div>

    <el-dialog title="Edit Columns" :visible.sync="editColumnsVisible" width="40%">
      <span>
        <span> <b>Select the columns to show :</b> </span> <br />
        <br />
        <el-checkbox-group v-model="checkedColumns">
          <el-checkbox v-for="column in columnLabelArray" :label="column" :key="column">{{ column }}</el-checkbox>
        </el-checkbox-group>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModal">Cancel</el-button>
        <el-button type="primary" @click="applyModalChanges">Apply</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VueTagsInput from '@johmun/vue-tags-input'
import SearchQuery from '@/resources/query/SearchQuery'
import { globalStylesDefaults } from '@/constants/global-styles.constants'

export default {
  name: 'TableToolbar',
  props: {
    searchProperties: { type: Array },
    activeFilterData: { type: Array },
    searchData: {
      default: function () {
        return []
      },
      type: [Array, Object]
    },
    initialTags: {
      default: function () {
        return []
      },
      type: [Array, String]
    },
    searchbarVisible: {
      default: true,
      type: Boolean
    },
    refreshVisible: {
      default: true,
      type: Boolean
    },
    columnEditVisible: {
      default: true,
      type: Boolean
    },
    reloadComponent: [Boolean],
    totalSearchProperties: { type: Array },
    disableSearchBox: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      tag: '',
      tags: [],
      validation: [
        {
          classes: 'min-length',
          rule: tag => tag.text.length < 1
        }
      ],
      queryInstance: undefined,
      queryCountText: undefined,
      editColumnsVisible: false,
      checkedColumns: [],
      columnLabelArray: [],
      inputContainer: null,
      inputElement: null,
      defaultInputColor: globalStylesDefaults.style.searchBg,
      activeInputColor: globalStylesDefaults.style.white,
      searchTagsData: [],
      disableAddFilterBtn: true
    }
  },
  computed: {
    searchQuery: function () {
      if (_.isUndefined(this.queryInstance)) {
        if (this.searchData instanceof Object) {
          return this.searchData
        } else {
          return new SearchQuery(this.searchData, this.searchProperties)
        }
      }
      return this.queryInstance
    },
    hasLeftToolbarSlot () {
      return this.$slots['left-toolbar-tools']
    },
    hasSearchActionsSlot () {
      return this.$slots['search-actions']
    },
    hasLocalActionsSlot () {
      return this.$slots['local-actions']
    }
  },
  watch: {
    activeFilterData: function(newVal) {
      this.tags = _.cloneDeep(newVal)
      this.handleTagChange(this.tags)
    }
  },
  methods: {
    getRecordCount () {
      let indexInfo
      if (!_.isEmpty(this.searchQuery)) {
        indexInfo = this.searchQuery.getIndexData()

        if (
          (this.searchQuery.searchTags && this.searchQuery.searchTags.length > 0) ||
          this.searchQuery.filteredSearch
        ) {
          return `${indexInfo.startIndex}-${indexInfo.endIndex} of ${this.searchQuery.getQueriedCount()}`
        }
        return `${indexInfo.startIndex}-${indexInfo.endIndex} of ${this.searchQuery.getCount()}`
      }
    },
    handleTagChange (newTags) {
      this.disableAddFilterBtn = !newTags.length || newTags.length > 5;
      this.searchTagsData.length = 0
      
      // applying search filter on new tags
      if (newTags.length) {
        let tagsArray = []
        newTags.forEach(tag => {
          tag.text = tag.text.trim()
          tagsArray.push(tag)
          this.searchTagsData.push(tag.text)
          this.searchData.searchData(tagsArray)
        })
      } else {
        // if tags are empty
        this.searchData.searchData(newTags)
      }

      if (newTags.length < this.tags.length) {
        // tag is deleted
        const [deletedTagName, deletedTagIdx] = this.getDifferenceBy(this.tags.map(tag => tag.text), newTags.map(tag => tag.text));
        this.$emit('deactivate-filter', 'delete', deletedTagName, deletedTagIdx)
      } else if (newTags.length > this.tags.length) {
        // tag is added manually
        const addedTag = _.differenceBy(newTags, this.tags, 'text')
        this.$emit('deactivate-filter', 'add', addedTag[0].text)
      }
      this.tags = _.cloneDeep(newTags)
      this.setPageNumber()
      this.$emit('update-querydata')
      this.setQueryCountText()
    },
    getDifferenceBy(arr1, arr2) {
      for (let i = 0; i < arr1.length; i++) {
        if (!arr2[i] || arr1[i] !== arr2[i]) {
          return [arr1[i], i];
        }
      }
    },
    setQueryCountText () {
      this.$set(this, 'queryCountText', this.getRecordCount())
    },
    setSearchTags () {
      _.isArray(this.initialTags)
        ? (this.tags = this.initialTags.map(text => ({ text })))
        : (this.tags = [{ text: this.initialTags }])
    },
    handleCommand (command) {
      if (command === 'Edit Columns') {
        this.editColumnsVisible = true
      }
    },
    closeModal () {
      this.editColumnsVisible = false
    },
    applyModalChanges () {
      this.editColumnsVisible = false
      this.$emit('update-columns-data', this.checkedColumns)
    },
    checkPreviousSelectedColumns () {
      this.searchProperties.forEach(property => {
        this.checkedColumns.push(property.label)
      })
    },
    refreshTable () {
      this.$emit('refresh-tabledata', {
        activePage: this.searchData.currentPage,
        searchTags: this.searchData.searchTags
      })
    },
    setPageNumber () {
      let totalRecords
      if (this.searchData.searchTags.length > 0) {
        totalRecords = this.searchData.queriedData.length
      } else {
        totalRecords = this.searchData.models.length
      }

      let updatedLastPageNumber = Math.floor(totalRecords / this.searchData.recordsPerPage)
      if (totalRecords % this.searchData.recordsPerPage !== 0) {
        updatedLastPageNumber += 1
      }
      if (updatedLastPageNumber < this.searchData.currentPage) {
        this.searchData.currentPage = updatedLastPageNumber
      }
    },
    onInputBlur () {
      this.setInputBackground(this.defaultInputColor)
    },
    onInputFocus () {
      this.disableAddFilterBtn = !this.tags.length;
      this.setInputBackground(this.activeInputColor)
    },
    setInputBackground (color) {
      if (this.inputContainer) {
        this.inputContainer.style.backgroundColor = color
      }
      if (this.inputElement) {
        this.inputElement.style.backgroundColor = color
      }
    },
    addSearchTagsToBtn() {
      this.$emit('add-searchtags', this.searchTagsData)
      this.disableAddFilterBtn = true
      this.$emit('deactivate-filter')
      // this.tags = []
      // this.handleTagChange(this.tags)
    }
  },
  beforeMount () {
    if (this.reloadComponent) {
      // setting search tags and queryData
      if (!_.isEmpty(this.initialTags)) {
        this.setSearchTags()
        this.handleTagChange(this.tags, false)
      } else {
        this.setPageNumber()
      }
    }
    // Setting visible columns
    this.totalSearchProperties.forEach(column => {
      if (
        _.indexOf(
          [
            'containerImageId',
            'instanceId',
            'agentDetails.vpcId',
            'agentDetails.region',
            'agentDetails.securityGroupsList'
          ],
          column.name
        ) < 0 &&
        _.indexOf(['expand', 'selection'], column.datatype) < 0
      ) {
        this.columnLabelArray.push(column.label)
      }
    })
    this.checkPreviousSelectedColumns()
  },
  mounted () {
    this.setSearchTags()
    this.setQueryCountText()

    this.inputContainer = this.$el.querySelector('.vue-tags-input')
    this.inputElement = this.$el.querySelector('.ti-new-tag-input')
    this.setInputBackground(this.defaultInputColor)
  },
  beforeDestroy () {
    this.queryInstance = undefined
  },
  components: { VueTagsInput }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.count-info {
  line-height: 53px;
}

.flex-4 {
  flex-grow: 4;
}

.flex-6 {
  flex-grow: 6;
}

.flex-8 {
  flex-grow: 8;
}

.flex-12 {
  flex-grow: 12;
}

.flex-14 {
  flex-grow: 14;
}

.icons-tools {
  text-align: right;
  > div {
    display: inline-block;
    vertical-align: top;
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-checkbox {
  width: 100%;
}

.el-checkbox + .el-checkbox {
  margin-left: 0px;
}

.search-box {
  height: 100%;
  margin: 39px 0px 16px 0px;
  align-items: flex-start;
}

.vue-tags-input {
  max-width: 360px;
  >>> .ti-tag .ti-tag-center {
        max-width: 26ch;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
}

.search-box-container {
  >>> .el-button {
    position: relative;
    left: 32%;
    bottom: 38px;
    height: 18px;
    width: 130px;
    font-family: Montserrat;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
  }
}

.vue-tags-search-box {
  position: relative;
  left: 30%;
  bottom: 31px;
}

.top-border { 
  border-top: 1px solid var(--border-color);
}

.active-filter {
  color: #1A90FA;
}

.filter-tooltip-container {
  width:138.9px;
  height:81.76px;
  font-size:11px;
  font-weight:500;
  letter-spacing:0;
  line-height:16px;
  color:#FFFFFF;
}

.filter-tooltip-header {
  height: 16px;
  width: 139px;
}

.filter-tooltip-body {
  height:64px;
  width:171px;
}

.filter-tooltip-body_idx {
  width:15px;
  float:left
}

.filter-tooltip-body_content {
  width:120px;
  text-align:left;
  margin-left:25px
}
</style>



// WEBPACK FOOTER //
// src/components/table/TableToolbar.vue